import React from 'react';
import {
  useFormContext,
} from 'react-hook-form';
import Controller from 'core/components/FormController';
import AddressFields from 'pages/Dashboard/components/AddressFields';
import {
  validateAddressInfo,
} from 'utils/react-hook-form';

export default function PatientAddressFields() {
  const { control } = useFormContext();

  return (
    <div className="flex flex-col gap-form-row populate-form">
      <Controller
        name="address"
        control={control}
        rules={{ validate: (value) => (validateAddressInfo(value) ? true : 'Enter valid address') }}
        render={({ field }) => (
          <AddressFields {...field} label="" />
        )}
      />
    </div>
  );
}
